module.exports = __webpack_public_path__ + "img/41.13b1c58a.jpg";